import { render, staticRenderFns } from "./14introduce.vue?vue&type=template&id=2b146086&scoped=true&"
import script from "./14introduce.vue?vue&type=script&lang=js&"
export * from "./14introduce.vue?vue&type=script&lang=js&"
import style0 from "./14introduce.vue?vue&type=style&index=0&id=2b146086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b146086",
  null
  
)

export default component.exports